import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { createActivityBooking, saveBooking } from '../../../services/bookingService';

const RestaurantCard = ({ restaurant, onShowAlternatives, tripDetails }) => {
  const [isAdding, setIsAdding] = useState(false);
  const [bookingAdded, setBookingAdded] = useState(false);

  const handleAddToBooking = () => {
    setIsAdding(true);
    try {
      const booking = createActivityBooking(restaurant, tripDetails);
      const result = saveBooking(booking);
      
      if (result?.success) {
        setBookingAdded(true);
        setTimeout(() => setBookingAdded(false), 3000);
      }
    } catch (error) {
      console.error('Error adding to booking:', error);
    } finally {
      setIsAdding(false);
    }
  };

  return (
    <div className="bg-background rounded-xl border border-border p-5 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h4 className="text-base font-semibold text-foreground mb-1">{restaurant?.name}</h4>
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2 py-1 bg-[#F4A261]/10 text-[#F4A261] text-xs font-medium rounded">
              {restaurant?.cuisine}
            </span>
            <div className="flex items-center gap-1">
              <Icon name="Star" size={12} className="text-yellow-500 fill-yellow-500" />
              <span className="text-xs font-medium text-foreground">{restaurant?.rating}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="space-y-2 mb-4">
        <div className="flex items-center gap-2">
          <Icon name="Clock" size={14} className="text-muted-foreground" />
          <span className="text-xs text-muted-foreground">
            Day {restaurant?.day} - {restaurant?.mealType}
          </span>
        </div>
        <div className="flex items-start gap-2">
          <Icon name="MapPin" size={14} className="text-muted-foreground mt-0.5" />
          <p className="text-xs text-muted-foreground">{restaurant?.location}</p>
        </div>
        <p className="text-sm text-muted-foreground">{restaurant?.description}</p>
        
        <div className="flex flex-wrap gap-1">
          {restaurant?.specialties?.slice(0, 3)?.map((specialty, index) => (
            <span key={index} className="px-2 py-0.5 bg-muted text-xs rounded">
              {specialty}
            </span>
          ))}
        </div>
      </div>

      <div className="border-t border-border pt-3 flex items-center justify-between">
        <div>
          <p className="text-xs text-muted-foreground">Total Cost</p>
          <p className="text-lg font-bold text-foreground">
            ₱{restaurant?.totalCost?.toLocaleString()}
          </p>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="xs"
            iconName="RefreshCw"
            onClick={onShowAlternatives}
          >
            Change
          </Button>
          <Button
            variant={bookingAdded ? "success" : "default"}
            size="xs"
            iconName={bookingAdded ? "Check" : "Plus"}
            onClick={handleAddToBooking}
            disabled={isAdding || bookingAdded}
            loading={isAdding}
          >
            {bookingAdded ? 'Added' : 'Add'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default RestaurantCard;